import styled from "styled-components"

export const NoWrapSpan = styled.span`
  white-space: nowrap;
`
